export const makeStringMatcher = expression => {
	const tokens = expression
		.toLowerCase()
		.split(/(\|\||&&|\(|\))/)
		.map(token => token.trim())
		.filter(Boolean);

	let i = 0;

	const parseExpression = () => parseOr();

	const parseOr = () => {
		let matcher = parseAnd();

		while (tokens[i] === "||") {
			i++;

			const left = matcher;
			const right = parseAnd();

			matcher = text => left(text) || right(text);
		}

		return matcher;
	};

	const parseAnd = () => {
		let matcher = parseValue();

		while (tokens[i] === "&&") {
			i++;

			const left = matcher;
			const right = parseValue();

			matcher = text => left(text) && right(text);
		}

		return matcher;
	};

	const parseValue = () => {
		const token = tokens[i++];

		if (token === "(") {
			const matcher = parseExpression();

			if (tokens[i] === ")") {
				i++;
			}

			return matcher;
		}

		return text => text.includes(token);
	};

	const matcher = parseExpression();

	return string => matcher(string.toLowerCase());
};
